export default {
  styleOverrides: {
    outlined: {
      gap: 16,
    },
  },
};
